import React, { Component } from "react";
import Select from "react-select";

// Components
import PhoneField from "../../../utils/PhoneField";
import ImageUploaderSimple from "../../../utils/ImageUploaderSimple";
import Loader from "../../../utils/Loader";
import ErrorWrap from "../../../utils/error-success/ErrorWrap";
import DynamicInputs from "../../../utils/DynamicInputs";

// CSS
import "../../../../css/forms/dropzone-simple.css";

class PersonalInfoFieldset extends Component {
	render() {
		const {
			data,
			errors,
			salutationsError,
			salutationsLoading,
			salutations,
			phoneTypesError,
			phoneTypesLoading,
			phoneTypes,
			inProcess
		} = this.props;
		
		return (
			<div className="fieldset">
				<div className="title-label">Personal Info</div>

				<div className="image-fields">
					<ImageUploaderSimple
						placeholder="Drag or select profile pic"
						loading={inProcess}
						initialImages={data.pic ? [data.pic] : []}
						required={false}
						type={"pic"}
						uploadAssetType={"reviewer"}
						handleExistingImageRemoval={this.props.clearPic}
						addPromise={promise => this.props.addImagePromise(promise)}
						clear={this.props.clearImageUploader}
					/>

					<div className="image-fields--col">
						<div className="floated-field-container">
							<div className="form-field half-field">
								<label htmlFor="province">Salutation:</label>

								{salutationsError ? (
									<ErrorWrap>{salutationsError}</ErrorWrap>
								) : salutationsLoading ? (
									<Loader />
								) : (
									<React.Fragment>
										{!!errors.salutation && ( <ErrorWrap animate={1}>{errors.salutation}</ErrorWrap> )}
										<Select
											classNamePrefix="react-select"
											placeholder={"Select one"}
											isClearable={false}
											isDisabled={inProcess}
											name={`salutation`}
											value={salutations.filter(
												({ id }) => id === data.salutation
											)}
											onChange={({ id }) => {
												this.props.updateSelectedValue(id, "salutation");
											}}
											options={salutations}
											getOptionLabel={({ id }) => id}
											getOptionValue={({ id }) => id}
										/>
									</React.Fragment>
								)}
							</div>

							<div className="form-field half-field">
								<label>Title:</label>

								{!!errors.title && ( <ErrorWrap animate={1}>{errors.title}</ErrorWrap> )}
								<input
									type="text"
									id="title"
									value={data.title}
									maxLength="255"
									disabled={inProcess}
									onKeyPress={e => this.props.handleKeyPress(e)}
									onChange={e => this.props.handleInputChange(e)}
								/>
							</div>
						</div>

						<div className="floated-field-container">
							<div className="form-field half-field">
								<label>First Name:</label>

								{!!errors.fname && ( <ErrorWrap animate={1}>{errors.fname}</ErrorWrap> )}
								<input
									type="text"
									id="fname"
									value={data.fname}
									maxLength="255"
									disabled={inProcess}
									onKeyPress={e => this.props.handleKeyPress(e)}
									onChange={e => this.props.handleInputChange(e)}
								/>
							</div>
							<div className="form-field half-field">
								<label>Last Name:</label>

								{!!errors.lname && ( <ErrorWrap animate={1}>{errors.lname}</ErrorWrap> )}
								<input
									type="text"
									id="lname"
									value={data.lname}
									maxLength="255"
									disabled={inProcess}
									onKeyPress={e => this.props.handleKeyPress(e)}
									onChange={e => this.props.handleInputChange(e)}
								/>
							</div>
						</div>

						<div className="form-field">
							<label>Email:</label>

							{!!errors.email && <ErrorWrap animate={1}>{errors.email}</ErrorWrap>}
							<input
								type="email"
								id="email"
								value={data.email}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>

						<div className="form-field">
							<label>Alternate Emails:</label>

							{!!errors.alternate_emails && (
								<ErrorWrap animate={1}>{errors.alternate_emails}</ErrorWrap>
							)}
							<DynamicInputs
								index="alternate_emails"
								addInputToCollection={this.props.addInputToCollection}
								hasItems={data.alternate_emails.length}
							>
								{data.alternate_emails.map((alt_email, i) => (
									<div key={i} className="dynamic-input">
										<input
											type="email"
											name="alternate_emails"
											value={alt_email}
											maxLength="255"
											disabled={this.props.inProgress}
											onKeyPress={e => this.props.handleKeyPress(e)}
											// onChange={e => this.props.handleInputChange(e)}
											onChange={e => this.props.handleInputChangeArray(e, i)}
										/>
										{!!i && (
											<span
												className="icon-cross"
												onClick={() =>
													this.props.deleteInputFromCollection(
														"alternate_emails",
														i
													)
												}
											/>
										)}
									</div>
								))}
							</DynamicInputs>
						</div>

						<div className="floated-field-container">
							<PhoneField
								label={"Phone"}
								phone={data.phone}
								extension={data.phone_extension}
								ext_name="phone_extension"
								errorPhone={errors.phone}
								errorExtension={errors.phone_extension}
								inProcess={inProcess}
								handleKeyPress={this.props.handleKeyPress}
								handleInputChange={this.props.handleInputChange}
								phone_name="phone"
							/>

							<div className="form-field half-field">
								<label htmlFor="province">Phone Type:</label>

								{phoneTypesError ? (
									<ErrorWrap>{phoneTypesError}</ErrorWrap>
								) : phoneTypesLoading ? (
									<Loader />
								) : (
									<React.Fragment>
										{!!errors.phoneTypes && ( <ErrorWrap animate={1}>{errors.phoneTypes}</ErrorWrap> )}
										<Select
											classNamePrefix="react-select"
											placeholder={"Select one"}
											isClearable={false}
											isDisabled={inProcess}
											name={`phone_type`}
											value={phoneTypes.filter(
												({ id }) => id === data.phone_type
											)}
											onChange={({ id }) => {
												this.props.updateSelectedValue(id, "phone_type");
											}}
											options={phoneTypes}
											getOptionLabel={({ title }) => title}
											getOptionValue={({ id }) => id}
										/>
									</React.Fragment>
								)}
							</div>
						</div>

						<div className="floated-field-container">
							<PhoneField
								label={"Phone (Alternate)"}
								phone={data.phone_alternate}
								extension={data.phone_alternate_extension}
								errorPhone={errors.phone_alternate}
								errorExtension={errors.phone_alternate_extension}
								inProcess={inProcess}
								handleKeyPress={this.props.handleKeyPress}
								handleInputChange={this.props.handleInputChange}
								phone_name="phone_alternate"
								ext_name="phone_alternate_extension"
							/>

							<div className="form-field half-field">
								<label htmlFor="province">Alternate Phone Type:</label>

								{phoneTypesError ? (
									<ErrorWrap>{phoneTypesError}</ErrorWrap>
								) : phoneTypesLoading ? (
									<Loader />
								) : (
									<React.Fragment>
										{!!errors.phoneTypes && ( <ErrorWrap animate={1}>{errors.phoneTypes}</ErrorWrap> )}
										<Select
											classNamePrefix="react-select"
											placeholder={"Select one"}
											isClearable={false}
											isDisabled={inProcess}
											name={`phone_alternate_type`}
											value={phoneTypes.filter(
												({ id }) => id === data.phone_alternate_type
											)}
											onChange={({ id }) => {
												this.props.updateSelectedValue(
													id,
													"phone_alternate_type"
												);
											}}
											options={phoneTypes}
											getOptionLabel={({ title }) => title}
											getOptionValue={({ id }) => id}
										/>
									</React.Fragment>
								)}
							</div>
						</div>
					</div>
				</div>

				<div className="fieldset-indent">
					<div className="form-field">
						<label>Organization:</label>

						{!!errors.organization && ( <ErrorWrap animate={1}>{errors.organization}</ErrorWrap> )}
						<input
							type="email"
							id="organization"
							value={data.organization}
							maxLength="255"
							disabled={inProcess}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
						/>
					</div>

					<div className="form-field checkbox">
						<label className="pb1">Language:</label>

						{!!errors.language && <ErrorWrap animate={1}>{errors.language}</ErrorWrap>}
						<div className="floated-field-container">
							<div
								className={`custom-label checkbox-label${
									inProcess ? " disabled-label" : ""
								}`}
							>
								<input
									type="radio"
									id="language_en"
									value="en"
									disabled={inProcess}
									checked={data.language === "en"}
									onChange={e => this.props.handleRadioClick(e, "language")}
								/>
								<label htmlFor="language_en">English</label>
							</div>

							<div
								className={`custom-label checkbox-label${
									inProcess ? " disabled-label" : ""
								}`}
							>
								<input
									type="radio"
									id="language_fr"
									value="fr"
									disabled={inProcess}
									checked={data.language === "fr"}
									onChange={e => this.props.handleRadioClick(e, "language")}
								/>
								<label htmlFor="language_fr">French</label>
							</div>

							<div
								className={`custom-label checkbox-label${
									inProcess ? " disabled-label" : ""
								}`}
							>
								<input
									type="radio"
									id="language_other"
									value="other"
									disabled={inProcess}
									checked={data.language === "other"}
									onChange={e => this.props.handleRadioClick(e, "language")}
								/>
								<label htmlFor="language_other">Other</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default PersonalInfoFieldset;



// WEBPACK FOOTER //
// ./src/components/admin/reviewers/form-components/PersonalInfoFieldset.js